export default {
  LOAD_CYCLE_CASE_LIST_START: 'LoadCycleCaseListStart',
  LOAD_CYCLE_CASE_LIST_END: 'LoadCycleCaseListEnd',
  TOGGLE_CYCLE_CASE_LIST_CONFIRM_DIALOG: 'ToggleCycleCaseListConfirmDialog'
};